module.exports = __webpack_public_path__ + "files/339a8b547519ee5774a1f358e25f55cd.woff";


//////////////////
// WEBPACK FOOTER
// ./non_npm_dependencies/google-fonts/fonts/lora-italic-webfont.woff
// module id = 700
// module chunks = 60